import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button, Alert, Form, Row, Col } from "react-bootstrap";
import { Paper, TextField, makeStyles } from "@material-ui/core";
import { Formik } from "formik";
import FormDataEntry from "../admin/FormDataEntry";
// import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
// import LabelOutlinedIcon from '@material-ui/icons/LabelOutlined';
import * as Admin from "../../../store/ducks/admin.duck";
import * as Registration from "../../../store/ducks/registration.duck";
import PlacesAutoComplete from "../../../components/AddressAutoComplete";
import * as Yup from "yup";
import { ToastContainer, Flip } from "react-toastify";
import { format, differenceInYears } from "date-fns";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../_metronic/_assets/css/app.css";
import "../../../../_metronic/_assets/css/app2.css";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

const SCORE_RANGES = {
  K10: { min: 10, max: 50 },
  K5: { min: 5, max: 25 },
  IAR: { min: 0, max: 100 }, // adjust if needed
};

export default function CSClientRegistration(props) {
  //
  const dispatch = useDispatch();
  const history = useHistory();
  const step = useSelector((state) => state.admin.CSClientRegistrationStep);
  //
  if (step === 1) {
    // console.log('step 1', step)
    return <CSClientRegistrationPart1 {...props} />;
  } else if (step === 2) {
    // console.log('step 2', step)
    return <CSClientRegistrationPart2 {...props} />;
  } else if (step === 3) {
    // console.log('step 3', step)
    return <CSClientRegistrationPart3 {...props} />;
  } else if (step === 4) {
    // console.log('step 4', step)
    dispatch(Admin.actions.clearCSClientRegistration());
    history.push("/csclients");
    return null;
  }
}

export function CSClientRegistrationPart1(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const contexts = useSelector((state) => state.reference.Contexts);

  const languages = useSelector((state) => state.reference.Languages);
  const countries = useSelector((state) => state.reference.Countries);
  const role = useSelector((state) => state.auth.roleDesc);
  const rolescope = useSelector((state) => state.auth.roleScope);

  const step = useSelector((state) => state.admin.CSClientRegistrationStep);
  const thisClient = useSelector((state) => state.admin.CSClient);

  const actualRegistered = useSelector((state) => state.admin.RegisteredPsychologists);
  const registeredPsychologists = actualRegistered.filter((psychologist) => psychologist.specialisttype === "centralisedservice");
  const timeZone = useSelector((state) => state.reference.TimeZone);
  //const areasOfInterestReference = useSelector(state =>  state.reference.AreasOfInterest)
  const centreName = useSelector((state) => state.auth.centreName);
  const currentAgentID = useSelector((state) => state.auth.csAgentID);
  const csCentres = useSelector((state) => state.admin.CsCentres);
  const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const browserTZMS =
    timeZone && timeZone.some((tz) => tz.ianaName === browserTZ) ? timeZone.find((tz) => tz.ianaName === browserTZ) : timeZone.find((tz) => tz.tzIndex === "6");
  // const areasOfInterest = areasOfInterestReference.filter(aoi => aoi.providertype === 'Psychologist' && aoi.focusAreaIndex && !aoi.program)
  const csAgents = useSelector((state) => state.admin.CsAgents);
  const csClientSaving = useSelector((state) => state.admin.CSClientSaving);
  // Email Duplicate Check
  const [emailIsDuplicate, setEmailIsDuplicate] = useState(false);
  const emailDuplicate = useSelector((state) => state.registration.EmailDuplicate);

  useEffect(() => {
    if (emailDuplicate === null || emailDuplicate === undefined) {
      return;
    }
    setEmailIsDuplicate(emailDuplicate === true);
    dispatch(Registration.actions.emailDuplicateClear());
  }, [emailDuplicate, dispatch]);

  const initClient = useMemo(
    () => ({
      id: 0,
      timezone: browserTZMS && browserTZMS.systemName,
      status: "Active",
      // clientAreasOfInterest: [],
      // Current Psychologist
      currentprovider: "",
      // Current Centre
      csCentreID: 0,
      clientID: 0,
      owner: currentAgentID ? currentAgentID : 0,
      csSessionExpect: "0",
      csSessionExpectComment: "",
      // Consent
      csConsent: "",
      csConsentStatus: "Not Provided",
      // Name Information
      firstname: "",
      preferredname: "",
      surname: "",
      pronouns: "",
      // Contact Information
      email: "",
      mobilephone: "",
      // Other Personal Information
      dob: undefined,
      gender: "Prefer not to say",
      // Address Information
      fulladdress: "",
      postcode: "",
      latitude: "",
      longitude: "",
      // Emergency Contact Information
      emergencycontactname1: "",
      emergencycontactphone1: "",
      emergencycontactrelation1: "",
      emergencycontactname2: "",
      emergencycontactphone2: "",
      emergencycontactrelation2: "",
      // GP Information
      gpName: "",
      gpClinicName: "",
      gpContactNumber: "",
      // Other fields
      medication: "",
      hopeToGetFromTreatment: "",
      centreClientId: "",
      appointmenttype: "0",
      translator: "No",
      translatorlanguage: "",
      supportPerson: "No",
      supportPersonDetail: "",
      // Demographic Information
      aboriginal: "4",
      homelessness: "3",
      labour: "1",
      lgbtiqa: "1",
      education: "6",
      disabilityStatus: "No",
      disabilityType: "",
      birthCountry: 1101,
      language: 13121113,
      proficiency: "0",
      notificationPreference: "BOTH",
    }),
    [browserTZMS, currentAgentID],
  );

  var [client, setClient] = useState(initClient);

  function handleClose() {
    // Go back to client list
    history.push("/csclients");
  }

  useEffect(() => {
    setClient({
      ...initClient,
      ...thisClient,
    });
  }, [thisClient, initClient]);

  function putClient(data) {
    // Sort out certain data fields
    // console.log(data)
    const formData = new FormData();

    // Helper function to append safely
    const appendField = (key, value) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    // Basic Info
    appendField("id", data.id || 0);
    appendField("status", data.status || "Active");
    appendField("previousstatus", data.previousstatus);

    // Name
    appendField("firstname", data.firstname);
    appendField("preferredname", data.preferredname);
    appendField("surname", data.surname);
    appendField("pronouns", data.pronouns);

    // Contact
    appendField("email", data.email);
    appendField("mobilephone", data.mobilephone);

    // Personal
    appendField("dob", data.dob);
    appendField("gender", data.gender);

    // Address
    appendField("fulladdress", data.fulladdress);
    appendField("postcode", data.postcode);
    appendField("latitude", data.latitude);
    appendField("longitude", data.longitude);

    // Emergency Contacts
    appendField("emergencycontactname1", data.emergencycontactname1);
    appendField("emergencycontactphone1", data.emergencycontactphone1);
    appendField("emergencycontactrelation1", data.emergencycontactrelation1);
    appendField("emergencycontactname2", data.emergencycontactname2);
    appendField("emergencycontactphone2", data.emergencycontactphone2);
    appendField("emergencycontactrelation2", data.emergencycontactrelation2);

    // Other
    appendField("timezone", data.timezone);
    appendField("appointmenttype", data.appointmenttype);
    appendField("notificationPreference", data.notificationPreference);
    appendField("translator", data.translator);
    appendField("translatorlanguage", data.translatorlanguage);
    appendField("supportPerson", data.supportPerson);
    appendField("supportPersonDetail", data.supportPersonDetail);
    appendField("currentprovider", data.currentprovider || "");
    appendField("listcolor", data.listcolor || "Black");

    // CS
    appendField("centreClientId", data.centreClientId);
    appendField("csCentreID", data.csCentreID);
    appendField("owner", data.owner);

    // Demographic
    appendField("aboriginal", data.aboriginal);
    appendField("homelessness", data.homelessness);
    appendField("labour", data.labour);
    appendField("lgbtiqa", data.lgbtiqa);
    appendField("education", data.education);
    appendField("disabilityStatus", data.disabilityStatus);
    appendField("disabilityType", data.disabilityType);
    appendField("birthCountry", data.birthCountry);
    appendField("language", data.language);
    appendField("proficiency", data.proficiency);

    // Page 2 Fields
    appendField("referralPurpose", data.referralPurpose || "");
    appendField("referralInformation", data.referralInformation || "");
    appendField("medication", data.medication || "");
    appendField("hopeToGetFromTreatment", data.hopeToGetFromTreatment || "");
    appendField("identifiedRisksAndAgreedManagement", data.identifiedRisksAndAgreedManagement || "");
    appendField("specialCircumstances", data.specialCircumstances || "");
    appendField("estimatedEndOfCareDate", data.estimatedEndOfCareDate || "");
    appendField("csSessionExpectation", data.csSessionExpectation || "0");
    appendField("gpName", data.gpName || "");
    appendField("gpClinicName", data.gpClinicName || "");
    appendField("gpContactNumber", data.gpContactNumber || "");

    // Registration Process
    appendField("csRegistrationStepCompleted", data.csRegistrationStepCompleted || 3);

    if (process.env.REACT_APP_DEBUG) {
      console.log("Saving FormData");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
    }

    dispatch(Admin.actions.putCSClient({ formData }));
  }

  const validationSchema = Yup.object().shape({
    firstname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("First Name is required"),
    preferredname: Yup.string().max(200, "Too Long"),
    surname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("Surname is required"),
    dob: Yup.string()
      .required("Date of Birth is required")
      .test("dob", "Please enter a valid date", function (value) {
        if (!value) return false;
        const date = new Date(value);
        // Invalid date
        if (isNaN(date.getTime())) {
          return false;
        }
        const age = differenceInYears(new Date(), date);
        // Under 18
        if (age < 18) {
          return this.createError({
            message: "Consumer must be over 18 years of age",
          });
        }
        // Over 100
        if (age > 100) {
          return this.createError({
            message: "Please enter a valid date",
          });
        }
        return true;
      }),
    email: Yup.string()
      .min(2, "Too Short")
      .max(200, "Too Long")
      .email("Enter a valid email")
      .required("Email is required")
      .test("duplicate-email", "This email address is already registered", () => !emailIsDuplicate),
    mobilephone: Yup.string()
      .required("Phone number is required")
      .matches(/^\d{10}$/, "Phone number must be 10 digits and numeric"),
    fulladdress: Yup.string().min(4, "Too Short").max(400, "Too Long").required("Address is required"),
    pronouns: Yup.string().max(20, "Too Long"),
    hopeToGetFromTreatment: Yup.string().max(4000, "Too Long"),
    emergencycontactname1: Yup.string().min(3, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
    emergencycontactrelation1: Yup.string().min(3, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
    emergencycontactphone1: Yup.string()
      .required("Phone number is required")
      .matches(/^\d{10}$/, "Emergency Contact Phone number must be 10 digits and numeric"),
    emergencycontactname2: Yup.string().min(3, "Too Short").max(100, "Too Long").nullable(),
    emergencycontactrelation2: Yup.string().min(3, "Too Short").max(50, "Too Long").nullable(),
    emergencycontactphone2: Yup.string()
      .matches(/^\d{10}$/, "Emergency Contact Phone number must be 10 digits and numeric")
      .nullable(),
    centreClientId: Yup.string().min(3, "Case Number should be at least 3 characters").max(50, "Case Number is too Long (maximum 50 characters)"),
    csCentreID: Yup.number().required("Please select a Centre").notOneOf([0], "Please select a Centre").nullable(false),
    owner: Yup.number().required("Please select a Primary Centre contact").notOneOf([0], "Please select a Primary Centre contact").nullable(false),
  });

  return (
    <>
      <h4>Add New Client</h4>
      <Row className="mb-4">
        <Col className="d-flex justify-content-between align-items-center">
          {[
            { step: 1, label: "Consumer Information" },
            { step: 2, label: "Referral Information" },
            { step: 3, label: "Consent" },
          ].map((item, index, arr) => {
            const isActive = step === item.step;
            const isComplete = step > item.step;

            return (
              <div key={item.step} className="flex-fill text-center position-relative">
                {/* Circle */}
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    margin: "0 auto",
                    backgroundColor: isComplete ? "#198754" : isActive ? "#0d6efd" : "#dee2e6",
                    color: isComplete || isActive ? "#fff" : "#6c757d",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    zIndex: 2,
                    position: "relative",
                  }}
                >
                  {isComplete ? "✓" : item.step}
                </div>

                {/* Label */}
                <div
                  style={{
                    marginTop: 8,
                    fontSize: "0.9rem",
                    color: isActive || isComplete ? "#212529" : "#6c757d",
                  }}
                >
                  {item.label}
                </div>

                {/* Connector */}
                {index < arr.length - 1 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 20,
                      left: "50%",
                      width: "100%",
                      height: 2,
                      backgroundColor: step > item.step ? "#198754" : "#dee2e6",
                      zIndex: 1,
                    }}
                  />
                )}
              </div>
            );
          })}
        </Col>
      </Row>

      {step === 1 && (
        <Formik
          enableReinitialize={true}
          initialValues={client}
          validationSchema={validationSchema}
          onSubmit={(values, actions) => {
            putClient(values);
          }}
        >
          {(props) => {
            const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched } = props;
            const change = (name, e) => {
              e.persist();
              handleChange(e);
            };
            const filteredAgents = csAgents.filter((agent) => String(agent.csCentreID) === String(values.csCentreID));
            return (
              <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
                  <Alert
                    variant="info"
                    style={{
                      columnCount: 1,
                      columns: "auto",
                      display: "block",
                    }}
                  >
                    Please ensure you have consent to provide consumer information to the Centralised Service prior to entering any referral information.
                    <br />
                    <br />
                    <strong>Note:</strong> ADHD/ASD assessments and medicolegal services (e.g. NDIS, Centrelink, fitness to work) are <strong>EXCLUDED</strong>{" "}
                    from the Centralised Service. For more details about excluded services, please refer to the{" "}
                    <a
                      href="https://files.ruralhealthconnect.com.au/fileStoreRHC/CentralisedService-Referralguidev1.1.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "white",
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      Referral Guide
                    </a>{" "}
                    or email the Centralised Service Admin team at{" "}
                    <a
                      href="mailto:csadmin@ruralhealthconnect.com.au"
                      style={{
                        color: "white",
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                    >
                      csadmin@ruralhealthconnect.com.au
                    </a>
                    .
                  </Alert>{" "}
                  <h5 style={{ marginBottom: "20px" }}>Centre Information</h5>
                  <Row>
                    <Col md="4">
                      <Form.Group style={{ width: "100%" }}>
                        <Form.Label>Centre *</Form.Label>
                        <Autocomplete
                          id="csCentre"
                          variant="outlined"
                          disableClearable
                          options={csCentres}
                          getOptionLabel={(option) => option.centerName}
                          value={csCentres.find((v) => String(v.id) === String(values.csCentreID)) || null}
                          onChange={(e, value) => {
                            setFieldValue("csCentreID", value ? value.id : "");
                            setFieldTouched("csCentreID", true);
                          }}
                          style={{
                            fullWidth: true,
                            display: "flex",
                            wrap: "nowrap",
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              variant="outlined"
                              margin="dense"
                              name="csCentreID"
                              error={touched.csCentreID && Boolean(errors.csCentreID)}
                              helperText={touched.csCentreID && errors.csCentreID}
                              style={{
                                backgroundColor: "white",
                                margin: 0,
                                padding: 0,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password",
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group style={{ width: "100%" }}>
                        <Form.Label>Primary Centre contact for client*</Form.Label>
                        <Autocomplete
                          id="owner"
                          variant="outlined"
                          options={filteredAgents}
                          disableClearable
                          getOptionLabel={(option) => option.firstname + " " + option.surname}
                          value={filteredAgents.find((v) => String(v.id) === String(values.owner)) || null}
                          onChange={(e, value) => {
                            setFieldValue("owner", value.id);
                            setFieldTouched("owner", true);
                          }}
                          style={{
                            fullWidth: true,
                            display: "flex",
                            wrap: "nowrap",
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              variant="outlined"
                              margin="dense"
                              name="owner"
                              error={touched.owner && Boolean(errors.owner)}
                              helperText={touched.owner && errors.owner}
                              style={{
                                backgroundColor: "white",
                                margin: 0,
                                padding: 0,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password",
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Case Number*</Form.Label>
                        <Form.Control
                          type="text"
                          name="centreClientId"
                          value={values.centreClientId || ""}
                          onChange={change.bind(null, "centreClientId")}
                          isInvalid={touched.centreClientId && !!errors.centreClientId}
                          isValid={touched.centreClientId && !errors.centreClientId}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.centreClientId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5 style={{ marginBottom: "20px" }}>Personal Information</h5>
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>First Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="firstname"
                          value={values.firstname}
                          onChange={change.bind(null, "firstname")}
                          autoComplete="new-password"
                          isInvalid={touched.firstname && !!errors.firstname}
                          isValid={touched.firstname && !errors.firstname}
                        />
                        <Form.Control.Feedback type="invalid">{errors.firstname}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Surname *</Form.Label>
                        <Form.Control
                          type="text"
                          name="surname"
                          value={values.surname}
                          onChange={change.bind(null, "surname")}
                          autoComplete="new-password"
                          isInvalid={touched.surname && !!errors.surname}
                          isValid={touched.surname && !errors.surname}
                        />
                        <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Preferred Name (Optional)</Form.Label>
                        <Form.Control
                          type="text"
                          name="preferredname"
                          value={values.preferredname}
                          onChange={change.bind(null, "preferredname")}
                          autoComplete="new-password"
                          isInvalid={touched.preferredname && !!errors.preferredname}
                          isValid={touched.preferredname && !errors.preferredname}
                        />
                        <Form.Control.Feedback type="invalid">{errors.preferredname}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Email * </Form.Label>
                        <Form.Control
                          type="text"
                          name="email"
                          value={values.email}
                          onChange={(e) => {
                            setEmailIsDuplicate(false);
                            change("email", e);
                          }}
                          onBlur={(e) => {
                            handleBlur(e);

                            if (e.currentTarget.value && e.currentTarget.value.length > 0) {
                              dispatch(Registration.actions.emailDuplicate({ emailAddress: e.currentTarget.value, checkType: "Client", clientId: values.id }));
                            }
                          }}
                          isInvalid={touched.email && !!errors.email}
                          isValid={touched.email && !errors.email}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>{" "}
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Phone Number *</Form.Label>
                        <Form.Control
                          type="text"
                          name="mobilephone"
                          value={values.mobilephone}
                          onChange={change.bind(null, "mobilephone")}
                          isInvalid={touched.mobilephone && !!errors.mobilephone}
                          isValid={touched.mobilephone && !errors.mobilephone}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.mobilephone}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Notification Preference *</Form.Label>
                        <Form.Control
                          as="select"
                          name="notificationPreference"
                          value={values.notificationPreference}
                          onChange={change.bind(null, "notificationPreference")}
                        >
                          <option value="EMAIL">Email</option>
                          <option value="SMS">SMS</option>
                          <option value="BOTH">SMS and Email</option>
                          <option value="NONE">None</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Date of Birth *</Form.Label>
                        <Form.Control
                          type="date"
                          name="dob"
                          value={values.dob}
                          onChange={change.bind(null, "dob")}
                          isInvalid={touched.dob && !!errors.dob}
                          isValid={touched.dob && !errors.dob}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Gender *</Form.Label>
                        <Form.Control as="select" name="gender" value={values.gender} onChange={change.bind(null, "gender")}>
                          <option value="Prefer not to say">Prefer not to say</option>
                          <option value="Female">Female</option>
                          <option value="Male">Male</option>
                          <option value="Other">Other</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Pronouns (Optional)</Form.Label>
                        <Form.Control
                          type="text"
                          name="pronouns"
                          value={values.pronouns}
                          onChange={change.bind(null, "pronouns")}
                          autoComplete="new-password"
                          isInvalid={touched.pronouns && !!errors.pronouns}
                          isValid={touched.pronouns && !errors.pronouns}
                        />
                        <Form.Control.Feedback type="invalid">{errors.pronouns}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Country of Birth *</Form.Label>
                        <Autocomplete
                          id="countryofbirth"
                          variant="outlined"
                          disableClearable
                          options={countries}
                          getOptionLabel={(option) => option.countryName}
                          value={countries.find((v) => String(v.countryCode) === String(values.birthCountry))}
                          onChange={(e, value) => {
                            setFieldValue("birthCountry", value.countryCode);
                          }}
                          style={{
                            fullWidth: true,
                            display: "flex",
                            wrap: "nowrap",
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              variant="outlined"
                              margin="dense"
                              name="CountryOfBirthSelector"
                              style={{
                                backgroundColor: "white",
                                margin: 0,
                                padding: 0,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password",
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5 style={{ marginBottom: "20px" }}>Address</h5>
                  <Row>
                    <Col md="9">
                      <Form.Group style={{ width: "100%" }}>
                        <Form.Label>Home Address (start typing to search) *</Form.Label>
                        <PlacesAutoComplete
                          currentID={values.id}
                          currentfulladdress={values.fulladdress}
                          setcurrentfulladdress={(value) => setFieldValue("fulladdress", value)}
                          setcurrentLatitude={(value) => setFieldValue("latitude", value)}
                          setcurrentLongitude={(value) => setFieldValue("longitude", value)}
                          setcurrentPostCode={(value) => setFieldValue("postcode", value)}
                          isInvalid={touched.fulladdress && !!errors.fulladdress}
                          isValid={touched.fulladdress && !errors.fulladdress}
                        />
                        {touched.fulladdress && !!errors.fulladdress ? <p className="error-help">{errors.fulladdress}</p> : ""}
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Reporting Post Code</Form.Label>
                        <Form.Control
                          type="text"
                          name="postcode"
                          value={values.postcode}
                          onChange={change.bind(null, "postcode")}
                          autoComplete="new-password"
                          isInvalid={touched.postcode && !!errors.postcode}
                          isValid={touched.postcode && !errors.postcode}
                        />
                        <Form.Control.Feedback type="invalid">{errors.postcode}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group style={{ width: "100%" }}>
                        <Form.Label>TimeZone *</Form.Label>
                        <Autocomplete
                          id="TimeZone"
                          variant="outlined"
                          options={timeZone}
                          disableClearable
                          getOptionLabel={(option) => option.name}
                          value={
                            timeZone.find((v) => String(v.systemName) === String(values.timezone)) ||
                            timeZone.find((v) => String(v.systemName) === String(browserTZMS && browserTZMS.systemName)) ||
                            null
                          }
                          onChange={(e, value) => {
                            setFieldValue("timezone", value.systemName);
                          }}
                          style={{
                            fullWidth: true,
                            display: "flex",
                            wrap: "nowrap",
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              variant="outlined"
                              margin="dense"
                              name="TimeZoneSelector"
                              style={{
                                backgroundColor: "white",
                                margin: 0,
                                padding: 0,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password",
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5 style={{ marginBottom: "20px" }}>Emergency Contacts</h5>
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Primary Emergency Contact*</Form.Label>
                        <Form.Control
                          type="text"
                          name="emergencycontactname1"
                          value={values.emergencycontactname1 || ""}
                          onChange={change.bind(null, "emergencycontactname1")}
                          isInvalid={touched.emergencycontactname1 && !!errors.emergencycontactname1}
                          isValid={touched.emergencycontactname1 && !errors.emergencycontactname1}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.emergencycontactname1}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Relationship*</Form.Label>
                        <Form.Control
                          type="text"
                          name="emergencycontactrelation1"
                          value={values.emergencycontactrelation1 || ""}
                          onChange={change.bind(null, "emergencycontactrelation1")}
                          isInvalid={touched.emergencycontactrelation1 && !!errors.emergencycontactrelation1}
                          isValid={touched.emergencycontactrelation1 && !errors.emergencycontactrelation1}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation1}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Phone *</Form.Label>
                        <Form.Control
                          type="text"
                          name="emergencycontactphone1"
                          value={values.emergencycontactphone1 || ""}
                          onChange={change.bind(null, "emergencycontactphone1")}
                          isInvalid={touched.emergencycontactphone1 && !!errors.emergencycontactphone1}
                          isValid={touched.emergencycontactphone1 && !errors.emergencycontactphone1}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.emergencycontactphone1}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Secondary Emergency Contact</Form.Label>
                        <Form.Control
                          type="text"
                          name="emergencycontactname2"
                          value={values.emergencycontactname2 || ""}
                          onChange={change.bind(null, "emergencycontactname2")}
                          isInvalid={touched.emergencycontactname2 && !!errors.emergencycontactname2}
                          isValid={touched.emergencycontactname2 && !errors.emergencycontactname2}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.emergencycontactname2}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Relationship</Form.Label>
                        <Form.Control
                          type="text"
                          name="emergencycontactrelation2"
                          value={values.emergencycontactrelation2 || ""}
                          onChange={change.bind(null, "emergencycontactrelation2")}
                          isInvalid={touched.emergencycontactrelation2 && !!errors.emergencycontactrelation2}
                          isValid={touched.emergencycontactrelation2 && !errors.emergencycontactrelation2}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation2}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          type="text"
                          name="emergencycontactphone2"
                          value={values.emergencycontactphone2 || ""}
                          onChange={change.bind(null, "emergencycontactphone2")}
                          isInvalid={touched.emergencycontactphone2 && !!errors.emergencycontactphone2}
                          isValid={touched.emergencycontactphone2 && !errors.emergencycontactphone2}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.emergencycontactphone2}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5 style={{ marginBottom: "20px" }}>Preferences and Needs</h5>
                  <Row>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Appointment Type *</Form.Label>
                        <Form.Control as="select" name="appointmenttype" value={values.appointmenttype} onChange={change.bind(null, "appointmenttype")}>
                          <option key="Video" value="0">
                            Video Call
                          </option>
                          <option key="Phone" value="1">
                            Phone Call
                          </option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Support Person Required *</Form.Label>
                        <Form.Control as="select" name="supportPerson" value={values.supportPerson} onChange={change.bind(null, "supportPerson")}>
                          <option value="No">No</option>
                          <option value="Yes">Yes</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    {values.supportPerson === "Yes" ? (
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Type of support person</Form.Label>
                          <Form.Control
                            type="text"
                            name="supportPersonDetail"
                            value={values.supportPersonDetail}
                            onChange={change.bind(null, "supportPersonDetail")}
                            autoComplete="new-password"
                            isInvalid={touched.supportPersonDetail && !!errors.supportPersonDetail}
                          />
                          <Form.Control.Feedback type="invalid">{errors.supportPersonDetail}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    ) : null}
                  </Row>
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Disability Status *</Form.Label>
                        <Form.Control as="select" name="disabilityStatus" value={values.disabilityStatus} onChange={change.bind(null, "disabilityStatus")}>
                          <option value="No">No</option>
                          <option value="Yes">Yes</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    {values.disabilityStatus === "Yes" ? (
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Disability Type</Form.Label>
                          <Form.Control
                            type="text"
                            name="disabilityType"
                            value={values.disabilityType}
                            onChange={change.bind(null, "disabilityType")}
                            autoComplete="new-password"
                            isInvalid={touched.disabilityType && !!errors.disabilityType}
                          />
                          <Form.Control.Feedback type="invalid">{errors.disabilityType}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    ) : null}
                  </Row>
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Main Language Spoken at Home *</Form.Label>
                        <Autocomplete
                          id="languageathome"
                          variant="outlined"
                          options={languages}
                          disableClearable
                          getOptionLabel={(option) => option.languageName}
                          value={languages.find((v) => String(v.languageCode) === String(values.language))}
                          onChange={(e, value) => {
                            setFieldValue("language", value.languageCode);
                          }}
                          style={{
                            fullWidth: true,
                            display: "flex",
                            wrap: "nowrap",
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              variant="outlined"
                              margin="dense"
                              name="LanguageAtHomeSelector"
                              style={{
                                backgroundColor: "white",
                                margin: 0,
                                padding: 0,
                              }}
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password",
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>

                    <Col md="2">
                      <Form.Group>
                        <Form.Label>Translator Required *</Form.Label>
                        <Form.Control as="select" name="translator" value={values.translator} onChange={change.bind(null, "translator")}>
                          <option value="No">No</option>
                          <option value="Yes">Yes</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    {values.translator === "Yes" ? (
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>Language</Form.Label>
                          <Form.Control
                            type="text"
                            name="translatorlanguage"
                            value={values.translatorlanguage}
                            onChange={change.bind(null, "translatorlanguage")}
                            autoComplete="new-password"
                            isInvalid={touched.translatorlanguage && !!errors.translatorlanguage}
                          />
                          <Form.Control.Feedback type="invalid">{errors.translatorlanguage}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    ) : null}
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>English Proficiency *</Form.Label>
                        <Form.Control as="select" name="proficiency" value={values.proficiency} onChange={change.bind(null, "proficiency")}>
                          <option value="0">Not applicable (persons under 5 years of age or who speak only English)</option>
                          <option value="1">Very well</option>
                          <option value="2">Well</option>
                          <option value="3">Not well</option>
                          <option value="4">Not at all</option>
                          <option value="9">Not stated/inadequately described</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5 style={{ marginBottom: "20px" }}>Demographics</h5>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Aboriginal and Torres Strait Islander Status *</Form.Label>
                        <Form.Control as="select" name="aboriginal" value={values.aboriginal} onChange={change.bind(null, "aboriginal")}>
                          <option value="4">Neither Aboriginal or Torres Strait Islander origin</option>
                          <option value="1">Aboriginal but not Torres Strait Islander origin</option>
                          <option value="2">Torres Strait Islander but not Aboriginal origin</option>
                          <option value="3">Both Aboriginal and Torres Strait Islander origin</option>
                          <option value="9">Not stated/inadequately described</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Homelessness Status *</Form.Label>
                        <Form.Control as="select" name="homelessness" value={values.homelessness} onChange={change.bind(null, "homelessness")}>
                          <option value="3">Not homeless</option>
                          <option value="1">Sleeping rough or in nonconventional accommodation</option>
                          <option value="2">Short-term or emergency accommodation</option>
                          <option value="9">Not stated/inadequately described</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Labour Force Status *</Form.Label>
                        <Form.Control as="select" name="labour" value={values.labour} onChange={change.bind(null, "labour")}>
                          <option value="1">Employed</option>
                          <option value="2">Unemployed</option>
                          <option value="3">Not in the labour force</option>
                          <option value="9">Not stated/inadequately described</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>LGBTIQA+ Status *</Form.Label>
                        <Form.Control as="select" name="lgbtiqa" value={values.lgbtiqa} onChange={change.bind(null, "lgbtiqa")}>
                          <option value="1">Straight / Heterosexual</option>
                          <option value="2">Gay or lesbian</option>
                          <option value="3">Bisexual</option>
                          <option value="4">Different term</option>
                          <option value="5">Don't know</option>
                          <option value="6">Prefer not to answer</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Highest Education Level Achieved *</Form.Label>
                        <Form.Control as="select" name="education" value={values.education} onChange={change.bind(null, "education")}>
                          <option value="6">Secondary education</option>
                          <option value="7">Primary education</option>
                          <option value="1">Postgraduate degree level</option>
                          <option value="2">Graduate diploma and Graduate Certificate level</option>
                          <option value="3">Bachelor degree level</option>
                          <option value="4">Advanced diploma and diploma level</option>
                          <option value="5">Certificate level</option>
                          <option value="8">Pre-primary education</option>
                          <option value="9">Other education</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </Paper>
                <Row className="mt-4">
                  <Col className="d-flex justify-content-between">
                    <Button
                      variant="secondary"
                      size="lg"
                      onClick={handleClose}
                      style={{
                        backgroundColor: "#6c757d",
                        borderColor: "#6c757d",
                        color: "#fff",
                      }}
                    >
                      Cancel
                    </Button>

                    <Button variant="primary" size="lg" type="submit" disabled={csClientSaving}>
                      {csClientSaving ? "Saving..." : "Save & Next"}
                    </Button>
                  </Col>
                </Row>
                {console.log("Error", errors)}
              </form>
            );
          }}
        </Formik>
      )}

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export function CSClientRegistrationPart2(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const role = useSelector((state) => state.auth.roleDesc);
  const rolescope = useSelector((state) => state.auth.roleScope);

  const step = useSelector((state) => state.admin.CSClientRegistrationStep);
  // console.log("CSClientRegistrationPart2 - Current Step from Redux:", step);
  const thisClient = useSelector((state) => state.admin.CSClient);

  const initClient = useMemo(
    () => ({
      referralInformation: "",
      referralPurpose: "",
      medication: "",
      hopeToGetFromTreatment: "",
      initalAssessment: "K10",
      recentAssessment: null,
      recentIAR: null,
      recentAssessmentFile: null,
      recentIARFile: null,
      newScoreType: "K10",
      newScore: "",
      newScoreDate: null,
      gpName: "",
      gpClinicName: "",
      gpContactNumber: "",
      hopeToGetFromTreatment: "",
      identifiedRisksAndAgreedManagement: "",
      specialCircumstances: "",
      estimatedEndOfCareDate: "",
      csSessionExpectation: "0",

      id: 0,
    }),
    [],
  );

  var [client, setClient] = useState(initClient);

  function handleClose() {
    // Go back to client list
    history.push("/csclients");
  }

  useEffect(() => {
    setClient({
      ...initClient,
      ...thisClient,
      initalAssessment: thisClient.initalAssessment?.trim() ? thisClient.initalAssessment : "K10",
    });
  }, [thisClient, initClient]);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  function putAdditionalClient(data, navigationAction) {
    const formData = new FormData();
    formData.append("id", thisClient.id);
    formData.append("firstname", thisClient.firstname || "");
    formData.append("email", thisClient.email || "");
    formData.append("mobilephone", thisClient.mobilephone || "");
    formData.append("notificationPreference", thisClient.notificationPreference || "");
    formData.append("referralPurpose", data.referralPurpose || "");
    formData.append("referralInformation", data.referralInformation || "");
    formData.append("medication", data.medication || "");
    formData.append("hopeToGetFromTreatment", data.hopeToGetFromTreatment || "");
    formData.append("identifiedRisksAndAgreedManagement", data.identifiedRisksAndAgreedManagement || "");
    formData.append("specialCircumstances", data.specialCircumstances || "");
    formData.append("estimatedEndOfCareDate", data.estimatedEndOfCareDate || "");
    formData.append("csSessionExpectation", data.csSessionExpectation || "0");
    // Navigation action
    if (navigationAction !== "exit" && navigationAction !== "back") {
      navigationAction = "next"; // default to next if not exit or back
    }
    formData.append("navigation", navigationAction || "");
    // GP
    formData.append("gpName", data.gpName || "");
    formData.append("gpClinicName", data.gpClinicName || "");
    formData.append("gpContactNumber", data.gpContactNumber || "");

    // Assessment choice
    formData.append("initalAssessment", data.initalAssessment || "");
    // ---------- FILES ----------
    if (data.initalAssessment === "Upload" && data.recentAssessmentFile) {
      formData.append("recentAssessmentFile", data.recentAssessmentFile);
      formData.append("newScoreType", data.newScoreType || "");
      formData.append("newScore", data.newScore || "");
      formData.append("newScoreDate", data.newScoreDate || "");
    }
    if (data.recentIARFile) {
      formData.append("recentIARFile", data.recentIARFile);
    }

    // ---------- DEBUG ----------
    if (process.env.REACT_APP_DEBUG) {
      console.log("Saving FormData");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
    }

    // ---------- DISPATCH ----------
    dispatch(Admin.actions.putCSClientAdditional({ formData }));
    // ---------- NAVIGATION ----------
    // if (navigationAction === "exit") {
    //   dispatch(Admin.actions.returnToFetchCSClients());
    // }
  }

  const minNonWhitespace = (message) => Yup.string().test("min-non-whitespace", message, (value) => (value?.trim().length ?? 0) >= 3);

  const validationSchema = Yup.object().shape({
    referralPurpose: minNonWhitespace("Must be at least 3 characters").max(4000, "Too Long").required("Purpose of Referral is required"),
    referralInformation: minNonWhitespace("Must be at least 3 characters")
      .max(4000, "Too Long")
      .required("Presenting concerns & relevant background is required"),
    medication: minNonWhitespace("Must be at least 3 characters").max(4000, "Too Long").required("Current medication is required"),
    hopeToGetFromTreatment: minNonWhitespace("Must be at least 3 characters")
      .max(4000, "Too Long")
      .required("Identified risks and agreed management strategies are required"),
    identifiedRisksAndAgreedManagement: minNonWhitespace("Must be at least 3 characters")
      .max(4000, "Too Long")
      .required("MMHC contact and process expectations are required"),
    estimatedEndOfCareDate: Yup.string()
      .nullable()
      .required("Estimated end of care date is required")
      .test("future-date", "Estimated end of care date must be in the future", (value) => {
        if (!value) return false;

        const today = new Date();
        const todayString = today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, "0") + "-" + String(today.getDate()).padStart(2, "0");

        return value >= todayString;
      }),
    csSessionExpectation: Yup.number()
      .transform((value, originalValue) => (originalValue === "" ? undefined : Number(originalValue)))
      .typeError("Please enter a valid number")
      .integer("Number of sessions must be a whole number")
      .min(1, "Number of sessions must be at least 1")
      .max(30, "Number of sessions cannot exceed 30")
      .required("Estimated number of sessions is required"),
    initalAssessment: Yup.string().required("Please select an assessment option"),
    recentAssessmentFile: Yup.mixed().when("initalAssessment", {
      is: "Upload",
      then: Yup.mixed()
        .required("Please upload your recent assessment")
        .test("fileExists", "Please upload your recent assessment", (value) => value instanceof File),
      otherwise: Yup.mixed().notRequired(),
    }),
    newScoreType: Yup.string()
      .nullable()
      .when("initalAssessment", {
        is: "Upload",
        then: (schema) => schema.required("Score type is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    newScore: Yup.number()
      .nullable()
      .transform((value, originalValue) => (originalValue === "" ? null : value))
      .when("initalAssessment", {
        is: "Upload",
        then: (schema) =>
          schema
            .required("Score is required")
            .typeError("Score must be a number")
            .integer("Score must be a whole number")
            .when("newScoreType", (newScoreType, schema) => {
              if (!newScoreType) return schema;

              const ranges = {
                K10: { min: 10, max: 50 },
                K5: { min: 5, max: 25 },
                IAR: { min: 0, max: 100 }, // adjust if needed
              };

              const range = ranges[newScoreType];
              if (!range) return schema;

              return schema
                .min(range.min, `${newScoreType} score must be between ${range.min} and ${range.max}`)
                .max(range.max, `${newScoreType} score must be between ${range.min} and ${range.max}`);
            }),
        otherwise: (schema) => schema.notRequired(),
      }),
    newScoreDate: Yup.date()
      .nullable()
      .transform((value, originalValue) => {
        // Handle empty string and invalid date
        if (!originalValue) return null;
        const date = new Date(originalValue);
        return isNaN(date.getTime()) ? null : date;
      })
      .when("initalAssessment", {
        is: "Upload",
        then: (schema) => schema.required("Score date is required").typeError("Please select a valid date"),
        otherwise: (schema) => schema.notRequired(),
      }),
    recentIARFile: Yup.mixed().when("recentIARFileURL", {
      is: (url) => url !== "Uploaded into Client File Library",
      then: (schema) => schema.required("IAR file is required").test("fileExists", "IAR file is required", (value) => value instanceof File),
      otherwise: (schema) => schema.notRequired(),
    }),
    gpName: Yup.string().max(200, "GP Name Too Long").nullable(),
    gpClinicName: Yup.string().max(200, "GP Clinic Name Too Long").nullable(),
    gpContactNumber: Yup.string()
      .matches(/^\d{10}$/, "GP Contact Phone number must be 10 digits and numeric")
      .nullable(),
  });

  return (
    <>
      <h4>Add New Client</h4>
      {/* Step Indicator */}
      <Row className="mb-4">
        <Col className="d-flex justify-content-between align-items-center">
          {[
            { step: 1, label: "Consumer Information" },
            { step: 2, label: "Referral Information" },
            { step: 3, label: "Consent" },
          ].map((item, index, arr) => {
            const isActive = step === item.step;
            const isComplete = step > item.step;

            return (
              <div key={item.step} className="flex-fill text-center position-relative">
                {/* Circle */}
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    margin: "0 auto",
                    backgroundColor: isComplete ? "#198754" : isActive ? "#0d6efd" : "#dee2e6",
                    color: isComplete || isActive ? "#fff" : "#6c757d",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    zIndex: 2,
                    position: "relative",
                  }}
                >
                  {isComplete ? "✓" : item.step}
                </div>

                {/* Label */}
                <div
                  style={{
                    marginTop: 8,
                    fontSize: "0.9rem",
                    color: isActive || isComplete ? "#212529" : "#6c757d",
                  }}
                >
                  {item.label}
                </div>

                {/* Connector */}
                {index < arr.length - 1 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 20,
                      left: "50%",
                      width: "100%",
                      height: 2,
                      backgroundColor: step > item.step ? "#198754" : "#dee2e6",
                      zIndex: 1,
                    }}
                  />
                )}
              </div>
            );
          })}
        </Col>
      </Row>

      {step === 2 && (
        <Formik
          enableReinitialize={true}
          initialValues={client}
          validationSchema={validationSchema}
          onSubmit={(values, actions) => {
            putAdditionalClient(values);
            // actions.setSubmitting(false);
          }}
        >
          {(props) => {
            const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched, setFieldError } = props;
            const validatePartialSave = async () => {
              const fieldsToValidate = [];

              if (values.csSessionExpectation !== "" && values.csSessionExpectation !== null && values.csSessionExpectation !== undefined) {
                fieldsToValidate.push("csSessionExpectation");
              }

              if (values.estimatedEndOfCareDate !== "" && values.estimatedEndOfCareDate !== null && values.estimatedEndOfCareDate !== undefined) {
                fieldsToValidate.push("estimatedEndOfCareDate");
              }

              let isValid = true;

              for (const field of fieldsToValidate) {
                try {
                  await validationSchema.validateAt(field, values);

                  // Remove any previous error
                  setFieldError(field, undefined);
                } catch (error) {
                  isValid = false;

                  // Put the Yup error into Formik
                  setFieldError(field, error.message);

                  // Make Formik display the error
                  setFieldTouched(field, true, false);
                }
              }

              return isValid;
            };

            const change = (name, e) => {
              e.persist();
              handleChange(e);
            };
            return (
              <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
                  <Alert variant="info">
                    This referral information helps our clinicians provide a quality service. You can either enter information directly into the fields below,
                    or if it is covered in the IAR or additional documents, you can note this (e.g. "see IAR") and upload them in the "Files" tab once you have
                    created a consumer profile. If some referral information is unknown or not available, please note this against relevant sections below.
                  </Alert>
                  <h5>Referral Information</h5>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Purpose of referral *</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          type="text"
                          name="referralPurpose"
                          value={values.referralPurpose}
                          onChange={change.bind(null, "referralPurpose")}
                          isInvalid={touched.referralPurpose && !!errors.referralPurpose}
                          isValid={touched.referralPurpose && !errors.referralPurpose}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.referralPurpose}</Form.Control.Feedback>
                        <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>What would the consumer like to achieve through this referral?</Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Presenting concerns & relevant background*</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          type="text"
                          name="hopeToGetFromTreatment"
                          value={values.hopeToGetFromTreatment}
                          onChange={change.bind(null, "hopeToGetFromTreatment")}
                          isInvalid={touched.hopeToGetFromTreatment && !!errors.hopeToGetFromTreatment}
                          isValid={touched.hopeToGetFromTreatment && !errors.hopeToGetFromTreatment}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.hopeToGetFromTreatment}</Form.Control.Feedback>
                        <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                          Please provide details that support collaborative care, such as frequency of case conferences, support needs, etc. If referral
                          information is described in the IAR please refer to it.
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Current Medication</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          type="text"
                          name="medication"
                          value={values.medication}
                          onChange={change.bind(null, "medication")}
                          isInvalid={touched.medication && !!errors.medication}
                          isValid={touched.medication && !errors.medication}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.medication}</Form.Control.Feedback>
                        <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                          Please provide details of client's current medication. If current medication is described in IAR please refer to it.
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Identified risks and agreed management strategies*</Form.Label>

                        <Form.Control
                          as="textarea"
                          rows={4}
                          type="text"
                          name="identifiedRisksAndAgreedManagement"
                          value={values.identifiedRisksAndAgreedManagement}
                          onChange={change.bind(null, "identifiedRisksAndAgreedManagement")}
                          isInvalid={touched.identifiedRisksAndAgreedManagement && !!errors.identifiedRisksAndAgreedManagement}
                          isValid={touched.identifiedRisksAndAgreedManagement && !errors.identifiedRisksAndAgreedManagement}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.identifiedRisksAndAgreedManagement}</Form.Control.Feedback>
                        <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                          Please provide details about any identified risks and agreed management plans. You can find additional information and a template in
                          the Centralised Service Clinical Risk Assessment and Management Policy in the Resources tab.
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group style={{ width: "100%" }}>
                        <Form.Label>Centre anticipated end of care*</Form.Label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-end",
                          }}
                        >
                          <Form.Control
                            type="date"
                            id="estimatedEndOfCareDate"
                            name="estimatedEndOfCareDate"
                            value={values.estimatedEndOfCareDate || ""}
                            onChange={(e) => setFieldValue("estimatedEndOfCareDate", e.target.value)}
                            onBlur={() => setFieldTouched("estimatedEndOfCareDate", true)}
                            isInvalid={touched.estimatedEndOfCareDate && Boolean(errors.estimatedEndOfCareDate)}
                            style={{
                              height: 38,
                              fontSize: 14,
                              backgroundColor: "#fff",
                            }}
                          />
                        </div>
                        <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                          Please estimate date of anticipated end of care. End of care date can be updated during consumers care.
                        </Form.Label>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Estimated total number of sessions</Form.Label>
                        <Form.Control
                          type="text"
                          name="csSessionExpectation"
                          value={values.csSessionExpectation}
                          onChange={change.bind(null, "csSessionExpectation")}
                          autoComplete="new-password"
                          isInvalid={touched.csSessionExpectation && !!errors.csSessionExpectation}
                        />
                        <Form.Control.Feedback type="invalid">{errors.csSessionExpectation}</Form.Control.Feedback>
                        <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                          Please estimate the total number of sessions. Number of sessions can be updated during consumers care.
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>MMHC contact and process expectations*</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          type="text"
                          name="referralInformation"
                          value={values.referralInformation}
                          onChange={change.bind(null, "referralInformation")}
                          isInvalid={touched.referralInformation && !!errors.referralInformation}
                          isValid={touched.referralInformation && !errors.referralInformation}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.referralInformation}</Form.Control.Feedback>
                        <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                          Please provide details of the contact and process expectations. If current process expectations are described in the IAR, please refer
                          to it.
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Special Circumstances</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          type="text"
                          name="specialCircumstances"
                          value={values.specialCircumstances}
                          onChange={change.bind(null, "specialCircumstances")}
                          isInvalid={touched.specialCircumstances && !!errors.specialCircumstances}
                          isValid={touched.specialCircumstances && !errors.specialCircumstances}
                          autoComplete="new-password"
                        />
                        <Form.Control.Feedback type="invalid">{errors.specialCircumstances}</Form.Control.Feedback>
                        <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                          Please provide details of any special circumstances. If relevant details are described in the IAR, please refer to it.
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <h5>Assessments</h5>
                  {values.recentIARFileURL === "Uploaded into Client File Library" ? (
                    <Row>
                      <Col md="6">
                        <Form.Group>
                          <Form.Label>IAR Upload Status</Form.Label>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "2rem",
                            }}
                          >
                            <span
                              className="text-muted"
                              style={{
                                fontSize: "1rem",
                                fontWeight: "bold",
                              }}
                            >
                              {values.recentIARFileURL || "No Upload"}
                            </span>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Upload IAR: *</Form.Label>
                          <Form.Control
                            type="file"
                            name="recentIARFile"
                            onChange={(event) => setFieldValue("recentIARFile", event.currentTarget.files[0])}
                            isInvalid={touched.recentIARFile && !!errors.recentIARFile}
                            isValid={touched.recentIARFile && !errors.recentIARFile}
                            className="form-control"
                            style={{ paddingTop: 6, paddingLeft: 6 }}
                          />
                          <Form.Control.Feedback type="invalid">{errors.recentIARFile}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>K10/K5 Assessment *</Form.Label>
                        <Form.Control as="select" name="initalAssessment" value={values.initalAssessment} onChange={change.bind(null, "initalAssessment")}>
                          <option value="K10">Complete K10 Assessment Online</option>
                          <option value="K5">Complete K5 Assessment Online</option>
                          <option value="Upload">Upload Recent K10 or K5 Assessment</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  {values.initalAssessment === "Upload" ? (
                    <>
                      <Alert variant="info">Please enter assessment information for uploaded file.</Alert>
                      <Row>
                        <Col md="3">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Score Type</Form.Label>
                            <Form.Control
                              as="select"
                              name="newScoreType"
                              value={values.newScoreType}
                              onChange={change.bind(null, "newScoreType")}
                              style={{ borderColor: "#D1D1D1" }}
                            >
                              <option value="K10">K10</option>
                              <option value="K5">K5</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>Score</Form.Label>
                            <Form.Control
                              type="text"
                              name="newScore"
                              value={values.newScore}
                              onChange={change.bind(null, "newScore")}
                              onBlur={() => setFieldTouched("newScore", true)}
                              isInvalid={touched.newScore && !!errors.newScore}
                            />
                            <Form.Control.Feedback type="invalid">{errors.newScore}</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md="2">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Date</Form.Label>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-end",
                              }}
                            >
                              <Form.Control
                                type="date"
                                id="newScoreDate"
                                name="newScoreDate"
                                value={values.newScoreDate || ""}
                                onChange={(e) => setFieldValue("newScoreDate", e.target.value)}
                                onBlur={() => setFieldTouched("newScoreDate", true)}
                                isInvalid={touched.newScoreDate && Boolean(errors.newScoreDate)}
                                style={{
                                  height: 38,
                                  fontSize: 14,
                                  backgroundColor: "#fff",
                                }}
                              />
                              {touched.newScoreDate && errors.newScoreDate && (
                                <Form.Control.Feedback type="invalid">{errors.newScoreDate}</Form.Control.Feedback>
                              )}{" "}
                            </div>
                          </Form.Group>
                        </Col>
                        <Col md="4">
                          <Form.Group>
                            <Form.Label>Upload Assessment:</Form.Label>
                            <Form.Control
                              type="file"
                              name="recentAssessmentFile"
                              onChange={(event) => setFieldValue("recentAssessmentFile", event.currentTarget.files[0])}
                              isInvalid={touched.recentAssessmentFile && !!errors.recentAssessmentFile}
                              isValid={touched.recentAssessmentFile && !errors.recentAssessmentFile}
                              className="form-control"
                              style={{ paddingTop: 6, paddingLeft: 6 }}
                            />
                            <Form.Control.Feedback type="invalid">{errors.recentAssessmentFile}</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                  <h5>GP Details</h5>
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>GP Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="gpName"
                          value={values.gpName}
                          onChange={change.bind(null, "gpName")}
                          autoComplete="new-password"
                          isInvalid={touched.gpName && !!errors.gpName}
                        />
                        <Form.Control.Feedback type="invalid">{errors.gpName}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>GP Clinic Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="gpClinicName"
                          value={values.gpClinicName}
                          onChange={change.bind(null, "gpClinicName")}
                          autoComplete="new-password"
                          isInvalid={touched.gpClinicName && !!errors.gpClinicName}
                        />
                        <Form.Control.Feedback type="invalid">{errors.gpClinicName}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>GP Phone Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="gpContactNumber"
                          value={values.gpContactNumber}
                          onChange={change.bind(null, "gpContactNumber")}
                          autoComplete="new-password"
                          isInvalid={touched.gpContactNumber && !!errors.gpContactNumber}
                        />
                        <Form.Control.Feedback type="invalid">{errors.gpContactNumber}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </Paper>
                {console.log("Errors", errors)}
                <Row className="mt-4">
                  <Col className="d-flex justify-content-between align-items-center">
                    <div>
                      <Button
                        variant="secondary"
                        size="lg"
                        style={{
                          backgroundColor: "#6c757d",
                          borderColor: "#6c757d",
                          color: "#fff",
                        }}
                        onClick={async () => {
                          if (await validatePartialSave()) {
                            putAdditionalClient(values, "exit");
                          }
                        }}
                      >
                        Save & Exit
                      </Button>
                    </div>

                    <div className="d-flex gap-3">
                      <Button
                        variant="primary"
                        size="lg"
                        style={{ marginRight: "16px" }}
                        onClick={async () => {
                          if (await validatePartialSave()) {
                            putAdditionalClient(values, "back");
                          }
                        }}
                      >
                        Save & Back
                      </Button>

                      <Button variant="primary" size="lg" type="submit">
                        Save & Next
                      </Button>
                    </div>
                  </Col>
                </Row>{" "}
              </form>
            );
          }}
        </Formik>
      )}

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export function CSClientRegistrationPart3(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const role = useSelector((state) => state.auth.roleDesc);
  const rolescope = useSelector((state) => state.auth.roleScope);
  const consentRef = useRef(null);

  var [showConsentForm, setShowConsentForm] = useState(false);
  const [navigationAction, setNavigationAction] = useState(null);
  var [formData, setFormData] = useState();

  const step = useSelector((state) => state.admin.CSClientRegistrationStep);
  const thisClient = useSelector((state) => state.admin.CSClient);
  const [hasConsentData, setHasConsentData] = useState(null);
  const submitGuard = useRef(false);

  const initClient = useMemo(
    () => ({
      id: 0,
      // Consent
      csConsent: "",
      csConsentStatus: "Not Provided",
    }),
    [],
  );

  var [client, setClient] = useState(initClient);

  useEffect(() => {
    setClient({
      ...initClient,
      ...thisClient,
    });
  }, [thisClient, initClient]);

  var [consentAccepted, setConsentAccepted] = useState(false);

  function handleClose() {
    // Go back to client list
    history.push("/csclients");
  }

  const handleConsentAction = (selectedValue) => {
    // Handle the action required for consent
    switch (selectedValue) {
      case "FormNow":
        displayConsentForm();
        break;
      case "FormOnSave":
        sendConsentEmail();
        break;
      case "Download":
        downloadConsentForm();
        break;
    }
  };

  const displayConsentForm = () => {
    // console.log("Displaying consent form...");
    setShowConsentForm(true);
    setConsentAccepted(true); // Assume consent accepted if form is shown
  };

  const sendConsentEmail = () => {
    // console.log("Sending email with consent form...");
    setConsentAccepted(true);
  };

  const downloadConsentForm = async () => {
    window.open("https://files.ruralhealthconnect.com.au/filestoreRHC//CSConsentForm.pdf", "_blank");
    setConsentAccepted(true);
  };

  async function putCSClientConsent(data) {
    // Ok to submit the form
    const consentFormData = consentRef.current;

    if (consentFormData) {
      const errors = await consentFormData.validateForm();

      if (Object.keys(errors).length > 0) {
        const touched = Object.keys(errors).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {});

        await consentFormData.setTouched(touched);

        return;
      }
    }

    const payload = {
      id: thisClient.id,
      firstname: thisClient.firstname,
      email: thisClient.email,
      mobilephone: thisClient.mobilephone,
      notificationPreference: thisClient.notificationPreference,
      csConsent: data["csConsent"],
      csConsentFormData: consentFormData?.values || null,
      navigation: navigationAction || "",
      formEntry: "X",
    };

    dispatch(Admin.actions.putCSClientConsent(payload));
  }

  return (
    <>
      <h4>Add New Client</h4>
      {/* Step Indicator */}
      <Row className="mb-4">
        <Col className="d-flex justify-content-between align-items-center">
          {[
            { step: 1, label: "Consumer Information" },
            { step: 2, label: "Referral Information" },
            { step: 3, label: "Consent" },
          ].map((item, index, arr) => {
            const isActive = step === item.step;
            const isComplete = step > item.step;

            return (
              <div key={item.step} className="flex-fill text-center position-relative">
                {/* Circle */}
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    margin: "0 auto",
                    backgroundColor: isComplete ? "#198754" : isActive ? "#0d6efd" : "#dee2e6",
                    color: isComplete || isActive ? "#fff" : "#6c757d",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    zIndex: 2,
                    position: "relative",
                  }}
                >
                  {isComplete ? "✓" : item.step}
                </div>

                {/* Label */}
                <div
                  style={{
                    marginTop: 8,
                    fontSize: "0.9rem",
                    color: isActive || isComplete ? "#212529" : "#6c757d",
                  }}
                >
                  {item.label}
                </div>

                {/* Connector */}
                {index < arr.length - 1 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 20,
                      left: "50%",
                      width: "100%",
                      height: 2,
                      backgroundColor: step > item.step ? "#198754" : "#dee2e6",
                      zIndex: 1,
                    }}
                  />
                )}
              </div>
            );
          })}
        </Col>
      </Row>
      {step === 3 && (
        <Formik
          enableReinitialize={true}
          initialValues={client}
          validationSchema={Yup.object().shape({
            csConsent: Yup.string().required("Please select a consent method"),
          })}
          onSubmit={(values, actions) => {
            if (submitGuard.current) {
              return;
            }

            submitGuard.current = true;

            putCSClientConsent(values);

            actions.setSubmitting(false);
          }}
        >
          {(props) => {
            const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting } = props;
            const saveDisabled =
              isSubmitting || (client && client.id === 0 && (!consentAccepted || values.csConsent === "" || (values.csConsent === "FormNow" && !formData)));

            const change = (name, e) => {
              e.persist();
              handleChange(e);
            };
            return (
              <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
                  <Alert variant="info">
                    Evidence of consent is required prior to booking appointments. The following options are available for collecting consent: Option 1. Review
                    and sign on this device, Option 2. Download consent form and then upload a signed copy, Option 3. Email a link to the consumer to complete
                    on their device. NOTE: Verbal consent can be noted using Option 1.
                  </Alert>
                  <Row>
                    <Col md="6">
                      <Form.Group className="mb-0" style={{ width: "100%" }}>
                        <Form.Label>Client Consent *</Form.Label>
                        <Form.Control
                          as="select"
                          name="csConsent"
                          value={values.csConsent}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setFieldValue("csConsent", selectedValue);
                            if (selectedValue) {
                              handleConsentAction(selectedValue);
                            }
                          }}
                        >
                          <option value="">Select Consent Method</option>
                          <option value="FormNow">Display on screen for electronic signing (inc. verbal consent)</option>
                          <option value="Download">Download for printing, signing and upload</option>
                          <option value="FormOnSave">Email to Client after registration</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    {values.csConsent === "FormOnSave" ? (
                      <Col md="6">
                        <Form.Group className="mb-0" style={{ width: "100%", marginTop: "25px" }}>
                          <Form.Label style={{ fontStyle: "italic", color: "blue" }}>
                            For clients registering remotely only. By sending this form you are confirming that the client has provided verbal consent to for
                            their details to be entered into the system. Consent form must be completed before an appointment is booked.
                          </Form.Label>
                        </Form.Group>
                      </Col>
                    ) : null}
                  </Row>
                </Paper>
                {values.csConsent === "FormNow" && (
                  <Row className="mt-4">
                    <Col md={{ span: 10, offset: 1 }}>
                      <Paper
                        elevation={2}
                        style={{
                          backgroundColor: "#fff",
                          padding: "20px",
                        }}
                      >
                        {process.env.REACT_APP_ENV === "dev" ? (
                          <FormDataEntry
                            formID={14357}
                            formDataID={0}
                            setShowFormData={setShowConsentForm}
                            setFormData={setFormData}
                            consent={true}
                            contextName="ConsentRegistration"
                            contextID={thisClient.id}
                            embedded={true}
                            consentFormValuesRef={consentRef}
                            setHasConsentData={setHasConsentData}
                          />
                        ) : (
                          <FormDataEntry
                            formID={14357}
                            formDataID={0}
                            setShowFormData={setShowConsentForm}
                            setFormData={setFormData}
                            consent={true}
                            contextName="ConsentRegistration"
                            contextID={thisClient.id}
                            embedded={true}
                            consentFormValuesRef={consentRef}
                            setHasConsentData={setHasConsentData}
                          />
                        )}
                      </Paper>
                    </Col>
                  </Row>
                )}

                <Row className="mt-4">
                  <Col className="d-flex justify-content-between align-items-center">
                    <div>
                      <Button
                        variant="secondary"
                        size="lg"
                        style={{
                          backgroundColor: "#6c757d",
                          borderColor: "#6c757d",
                          color: "#fff",
                        }}
                        onClick={() => dispatch(Admin.actions.returnToFetchCSClients())}
                      >
                        Exit
                      </Button>
                    </div>

                    <div className="d-flex gap-3">
                      <Button variant="primary" size="lg" style={{ marginRight: "16px" }} onClick={() => dispatch(Admin.actions.putClientRegistrationStep(2))}>
                        Back
                      </Button>

                      <Button
                        variant="primary"
                        size="lg"
                        type="submit"
                        disabled={
                          client &&
                          client.id === 0 &&
                          (!consentAccepted ||
                            (consentAccepted && values.csConsent === "") ||
                            (values.csConsent === "FormNow" && (formData === null || formData === undefined || formData === "")))
                        }
                        onClick={() => setNavigationAction("next")}
                      >
                        {!consentAccepted || (consentAccepted && values.csConsent === "")
                          ? "Unable to Save - Consent Not Set"
                          : values.csConsent === "FormNow" && (!hasConsentData || hasConsentData.length === 0)
                            ? "Unable to Save - Consent Form Not Signed"
                            : "Finish"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            );
          }}
        </Formik>
      )}

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
